import React, { useState, useEffect } from 'react';
import cookies from 'next-cookies'
import classNames from 'classnames';
import FooterContainer from "../containers/homepage/Footer";

import { useAuth } from '../providers/Auth';

import '../styles/components/footer.scss';

const Footer = ({ className, pathName, isBengkel }) => {
  const [path, setPath] = useState("");
  const [userMode, setUserMode] = useState(true);
  const { authToken } = useAuth();

  useEffect(() => {
    if (cookies().mode === 'user' || !cookies().mode) {
      setUserMode(true);
    } else {
      setUserMode(false);
    }

    if (path === "") {
      setPath(window.location.pathname);
    }
  }, []);

  if (
    [
      '/',
      '/cara-beli',
      '/payment-link/[id]',
      '/plans',
      '/tentang',
      '/account/login',
      '/account/register',
      '/agents/register/[slug]',
      '/bantuan-zendesk',
      '/compare',
      '/contact-us/[lead_id]',
      '/privasi', '/ketentuan',
      '/pusat-bantuan',
    ].includes(pathName)
  ) {
    return null;
  }

  {/* Only show regular footer on homepage and user hasn't logged in */ }
  const defineShowRegFooter = () => {
    if (typeof window !== 'undefined') {
      if (!authToken) {
        return path === "/" || isBengkel;
      }
      return false;
    }

    return true;
  }

  return (
    <div className={classNames('pt-3', 'footer__wrapper', className, pathName === '/agents/invite' && 'shadow-none')}>
      <div className="container">
        <FooterContainer 
          showSectionInsuranceList={false} 
          showSectionCompanyInformation={false} 
        />
      </div>
    </div>
  );
}
export default Footer;
